<div class="vtr-container-collapsible"
	[ngClass]="{'white-theme': theme === 'white', 'blue-theme': theme === 'blue', 'dark-theme': theme === 'dark'}">
	<div class="row">
		<div class="col">
			<div class="card">
				<div class="card-header"
					[class.hide-border-bottom]="isCollapsed">
					<div class="container-fluid">
						<div class="row flex-nowrap align-items-center">
							<div class="col-auto text-left mr-auto mb-0 header py-2 px-0 mt-2"
								[innerHTML]="transform('&lt;h'+headerLevel + ' class=&quot;h2 collapse-header font-weight-light&quot; ' + 'tabindex=&quot;-1&quot; ' +
                                'id=&quot;'+collapseLinkId+'-collapse-card-title&quot;' + '&gt;' + cardTitle + '&lt;/h'+headerLevel + '&gt;')">
							</div>
							<div class="col-auto p-0"
								*ngIf="allowCollapse">
								<div class="collapse-control"
									[tabindex]="tabIndex ? tabIndex : 0"
									id="{{collapseLinkId+'-collapse-link'}}"
									[attr.aria-label]="cardTitle+' card'"
									(click)="onToggle()"
									(keyup.enter)="onToggle()"
									role="button"
									[attr.aria-expanded]="!isCollapsed">

									<ng-container *ngIf="isCollapsed;else expanded">
										<div class="collapse-text"
											id="{{collapseLinkId+'-expand-title'}}">
											<!-- Expand -->
											{{'common.ui.expand' | translate}}
										</div>
										<fa-icon [icon]="['fal', 'chevron-down']"
											role="img"
											aria-label="Arrow Down"></fa-icon>
									</ng-container>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card-body"
					[ngbCollapse]="isCollapsed">
					<!-- what ever content is inside the component tags, goes here -->
					<ng-content></ng-content>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #expanded>
	<div
		class="collapse-text"
		id="{{collapseLinkId+'-collapse-title'}}">
		<!-- to Collapse -->
		{{'common.ui.collapse' | translate}}
	</div>

	<fa-icon
		[icon]="['fal', 'chevron-up']"
		role="img"
		aria-label="Arrow Up"></fa-icon>
</ng-template>
